import api from '../../../../services/api';

export const RANK_MAPPING_LOADING = 'RANK_MAPPING_LOADING';
export const RANK_MAPPING_ERROR = 'RANK_MAPPING_ERROR';
export const SET_RANK_MAPPING_SETTINGS = 'SET_RANK_MAPPING_SETTINGS';
export const SET_RANK_MAPPINGS = 'SET_RANK_MAPPINGS';
export const SET_RANK_MAPPING_PAGINATION = 'SET_RANK_MAPPING_PAGINATION';

export const setLoading = (loading) => ({ type: RANK_MAPPING_LOADING, payload: loading });
export const setError = (error) => ({ type: RANK_MAPPING_ERROR, payload: error });

export const fetchRankMappingSettings = () => async (dispatch) => {
  dispatch(setLoading(true));
  try {
    const response = await api.get('/rank-mappings/settings');
    dispatch({ type: SET_RANK_MAPPING_SETTINGS, payload: response.data?.data || {} });
    return { success: true, data: response.data?.data || {} };
  } catch (error) {
    dispatch(setError(error.response?.data?.message || error.message));
    return { success: false, error: error.message };
  } finally {
    dispatch(setLoading(false));
  }
};

export const updateRankMappingSettings = (settings) => async (dispatch) => {
  dispatch(setLoading(true));
  try {
    const response = await api.put('/rank-mappings/settings', settings);
    dispatch({ type: SET_RANK_MAPPING_SETTINGS, payload: response.data?.data || {} });
    return { success: true, data: response.data?.data || {} };
  } catch (error) {
    dispatch(setError(error.response?.data?.message || error.message));
    return { success: false, error: error.response?.data?.message || error.message };
  } finally {
    dispatch(setLoading(false));
  }
};

export const fetchRankMappings = (params = {}) => async (dispatch, getState) => {
  dispatch(setLoading(true));
  try {
    const state = getState().categoryManagement?.rankMapping || {};
    const pagination = state.pagination || { current: 1, pageSize: 50 };
    const query = new URLSearchParams();
    query.append('page', params.page || pagination.current || 1);
    query.append('pageSize', params.pageSize || pagination.pageSize || 50);
    if (params.search) query.append('search', params.search);
    if (params.isActive && params.isActive !== 'all') query.append('isActive', params.isActive);

    const response = await api.get(`/rank-mappings?${query.toString()}`);
    dispatch({ type: SET_RANK_MAPPINGS, payload: response.data?.rows || [] });
    dispatch({
      type: SET_RANK_MAPPING_PAGINATION,
      payload: {
        current: response.data?.pagination?.page || 1,
        pageSize: response.data?.pagination?.pageSize || 50,
        total: response.data?.pagination?.total || 0
      }
    });
    return { success: true, data: response.data };
  } catch (error) {
    dispatch(setError(error.response?.data?.message || error.message));
    return { success: false, error: error.message };
  } finally {
    dispatch(setLoading(false));
  }
};

export const syncRankMappings = (settings) => async (dispatch) => {
  dispatch(setLoading(true));
  try {
    const response = await api.post('/rank-mappings/sync', settings);
    await dispatch(fetchRankMappingSettings());
    return { success: true, data: response.data?.data || response.data };
  } catch (error) {
    dispatch(setError(error.response?.data?.message || error.message));
    return { success: false, error: error.response?.data?.message || error.message };
  } finally {
    dispatch(setLoading(false));
  }
};

export const applyRankMappings = () => async (dispatch) => {
  dispatch(setLoading(true));
  try {
    const response = await api.post('/rank-mappings/apply');
    return { success: true, data: response.data?.data || {} };
  } catch (error) {
    dispatch(setError(error.response?.data?.message || error.message));
    return { success: false, error: error.response?.data?.message || error.message };
  } finally {
    dispatch(setLoading(false));
  }
};

export const createRankMapping = (data) => async (dispatch) => {
  dispatch(setLoading(true));
  try {
    const response = await api.post('/rank-mappings', data);
    return { success: true, data: response.data?.data || {} };
  } catch (error) {
    dispatch(setError(error.response?.data?.message || error.message));
    return { success: false, error: error.response?.data?.message || error.message };
  } finally {
    dispatch(setLoading(false));
  }
};

export const deleteRankMapping = (id) => async (dispatch) => {
  dispatch(setLoading(true));
  try {
    await api.delete(`/rank-mappings/${id}`);
    return { success: true };
  } catch (error) {
    dispatch(setError(error.response?.data?.message || error.message));
    return { success: false, error: error.response?.data?.message || error.message };
  } finally {
    dispatch(setLoading(false));
  }
};
